Controller.$inject = ['$timeout'];

function Controller($timeout) {
    const self = this;

    self.handleChange = ($event) => {
        $timeout(() => {
            self.onChange({$event});
        })
    }
}

export function HuiInputCheckbox() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            ngModel: '=',
            ngValue: '<',
            disabled: '<',
            isPartial: '<',
            hName: '@',
            onChange: '&'
        },
        transclude: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: ($element, $attrs) => {
            return `
                <label class="hui hui-input hui-input-checkbox"
                       role="checkbox"
                       tabindex="0"
                       aria-labelledby="checkbox-input"
                       aria-checked="{{ $huiCtrl.ngModel }}"
                       ng-class="{ 'disabled': $huiCtrl.disabled }">
                        <input 
                            type="checkbox"
                            name="{{$huiCtrl.hName}}"
                            ng-disabled="$huiCtrl.disabled"
                            ng-value="$huiCtrl.ngValue"
                            ng-model="$huiCtrl.ngModel"
                            ng-change="$huiCtrl.handleChange($event)">
                        <div class="hui-check-icon" ng-class="{ 'checked': $huiCtrl.ngModel }">
                            <i class="fa"
                               ng-if="$huiCtrl.ngModel || $huiCtrl.isPartial"
                               ng-class="{
                                    'fa-check': $huiCtrl.ngModel && !$huiCtrl.isPartial,
                                    'fa-minus': $huiCtrl.ngModel && $huiCtrl.isPartial
                                }"></i>
                        </div>
                        <span ng-transclude></span>
                </label>
            `;
        }
    };
}